<template>
	<div class="detail-page" v-loading="detailLoading">
		<el-button type="text" icon="el-icon-arrow-left" @click="$emit('back')" style="padding-top: 0">Return</el-button>

		<el-form :model="detailData" ref="detailForm" label-position="right" label-width="200px" size="small">
			<el-collapse v-model="activeCollapseNames" class="detail-collapse">
			<!-- Project Key Info -->
			<el-collapse-item name="keyInfo">
				<template slot="title"><span class="card-header">Project Key Info</span></template>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Project Number:" class="red-label">
							<el-input disabled v-model="detailData.projectNumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Representative Office:">
							<el-select disabled filterable v-model="detailData.representativeOffice" placeholder="Please select" style="width:100%">
								<el-option v-for="item in representativeOfficeList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Business Type:">
							<el-select disabled v-model="detailData.businessType" placeholder="Please select" style="width:100%">
								<el-option v-for="item in businessTypeList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="IB Service:">
							<el-radio-group disabled v-model="detailData.ibService">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Project Name:">
							<el-tooltip :content="detailData.projectName" placement="top" :disabled="!detailData.projectName">
								<el-input disabled v-model="detailData.projectName"></el-input>
							</el-tooltip>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="End User (Customer):">
							<el-input disabled v-model="detailData.endUser"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Industry:">
							<el-select disabled filterable v-model="detailData.industry" placeholder="Please select" style="width:100%">
								<el-option v-for="item in industryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Sub Industry:">
							<el-select disabled filterable v-model="detailData.subIndustry" placeholder="Please select" style="width:100%">
								<el-option v-for="item in subIndustryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Hardware Delivery Country:">
							<el-select disabled filterable v-model="detailData.hardwareDeliveryCountry" placeholder="Please select" style="width:100%">
								<el-option v-for="item in hwDeliveryCountryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Service Delivery Country:">
							<el-select disabled filterable v-model="detailData.serviceDeliveryCountry" placeholder="Please select" style="width:100%">
								<el-option v-for="item in svcDeliveryCountryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Attach Service Included:">
							<el-radio-group disabled v-model="detailData.attachServiceIncluded">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Maintenance Service SLA:">
							<el-select disabled v-model="detailData.maintenanceServiceSla" placeholder="Please select" style="width:100%">
								<el-option v-for="item in slaList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Tier one Partner:">
							<el-select disabled filterable v-model="detailData.tierOnePartner" placeholder="Please select" style="width:100%">
								<el-option v-for="item in tier1PartnerList" :key="item.companyName" :label="item.companyName" :value="item.companyName"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Salesman(Owner):">
							<el-input disabled v-model="detailData.salesman"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="White List Account:" class="red-label">
							<el-radio-group disabled v-model="detailData.whiteListAccount">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="3S2S Project:" class="red-label">
							<el-radio-group disabled v-model="detailData.s3s2sProject">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Project Level:" class="red-label">
							<el-select disabled v-model="detailData.majorProjectLevel" placeholder="Please select" style="width:100%">
								<el-option v-for="item in projectLevelList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Product List:">
							<span>
								<a class="detail-link" :class="{'detail-link-disabled': !detailData.hasProductOrder}" @click="detailData.hasProductOrder && openProductOrder()">Product Order</a>
								<a class="detail-link" style="margin-left:12px;" :class="{'detail-link-disabled': !detailData.hasServiceContract}" @click="detailData.hasServiceContract && openServiceContract()">Service Contract</a>
							</span>
						</el-form-item>
					</el-col>
				</el-row>
			</el-collapse-item>

			<!-- Detailed Information (可展开) -->
			<el-collapse-item name="detailInfo">
				<template slot="title">
					<span class="card-header">Detailed Information</span>
					<el-button size="mini" type="primary" @click.stop="toggleDetailInfo" style="position:absolute;right:50px">{{ activeCollapseNames.includes('detailInfo') ? '− Fold' : '+ Unfold' }}</el-button>
				</template>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Project Level(MKT):">
								<el-select disabled v-model="detailData.projectLevel" placeholder="Please select" style="width:100%">
										<el-option v-for="item in projectLevelList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
									</el-select>
								</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Expected Deal Price(KUSD):">
								<el-input disabled v-model="detailData.estimatedRevenueKusd"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Currency:">
								<el-input disabled v-model="detailData.currencyIsoCode"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Deal Type:">
								<el-input disabled v-model="detailData.dealType"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Order Type:">
								<el-input disabled v-model="detailData.logincMethod"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Account Code:">
								<el-input disabled v-model="detailData.accountCode"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="PL1:">
								<el-input disabled v-model="detailData.pl1"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="PL2:">
								<el-input disabled v-model="detailData.pl2"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Solution Label:">
								<el-input disabled v-model="detailData.solutionLabel"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Service Delivery City:">
								<el-input disabled v-model="detailData.serviceDeliveryCity"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Service Delivery Address:">
								<el-input disabled v-model="detailData.serviceDeliveryAddress"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12" class="no-col-padding-left">
							<el-form-item label="Estimated Service Revenue(KUSD):" class="no-label-padding-right">
								<el-input disabled v-model="detailData.estimatedServiceRevenueKusd"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Maintenance Service Year:">
								<el-input disabled v-model="detailData.maintenanceServiceYear"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Professional Service:">
								<el-input disabled v-model="detailData.professionalService"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Tier two Partner:">
								<el-input disabled v-model="detailData.tierTwoPartner"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Tier three Partner:">
								<el-input disabled v-model="detailData.tierThreePartner"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Project Delivery Partner:">
								<el-input disabled v-model="detailData.projectDeliveryPartner"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="SE:">
								<el-input disabled v-model="detailData.se"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Order Quarter:">
								<el-input disabled v-model="detailData.orderQuarter"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Shipping Date:">
								<el-input disabled v-model="detailData.shippingDate"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Framework:">
								<el-radio-group disabled v-model="detailData.framework">
									<el-radio :label="true">Y</el-radio>
									<el-radio :label="false">N</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Sales Stage:">
								<el-input disabled v-model="detailData.stageName"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Mark Won Status:">
								<el-input disabled v-model="detailData.markWonStatus"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Project Order No.:">
								<el-tooltip placement="top" :disabled="!projectOrderNoMultiple">
									<div slot="content">
										<div v-for="(item, idx) in projectOrderNoItems" :key="idx" style="line-height:1.8">{{ item }}</div>
									</div>
									<el-input disabled v-model="detailData.projectOrderNo" :class="{'multi-value-input': projectOrderNoMultiple}"></el-input>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Product Order No.:">
								<el-tooltip placement="top" :disabled="!productOrderNoMultiple">
									<div slot="content">
										<div v-for="(item, idx) in productOrderNoItems" :key="idx" style="line-height:1.8">{{ item }}</div>
									</div>
									<el-input disabled v-model="detailData.productOrderNo" :class="{'multi-value-input': productOrderNoMultiple}"></el-input>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Presales Test Statistics:">
								<el-input disabled v-model="detailData.presalesTestStatistics"></el-input>
							</el-form-item>
						</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="IF Early Shipment:">
							<el-radio-group v-model="detailData.ifEarlyShipment">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="IF Competitor Substitution:">
							<el-radio-group v-model="detailData.ifCompetitorSubstitution">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Project Status:">
							<el-select :disabled="detailData.isMajorProject" v-model="detailData.projectStatus" placeholder="Please select" style="width:100%">
								<el-option v-for="item in projectStatusList" :key="item.labelKey" :label="item.labelValue" :value="item.labelKey"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="AT:">
							<el-radio-group :disabled="detailData.isMajorProject" v-model="detailData.projectSummaryReport">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Service Contract No.:">
								<el-tooltip placement="top" :disabled="!serviceContractMultiple">
									<div slot="content">
										<div v-for="(item, idx) in serviceContractItems" :key="idx" style="line-height:1.8">{{ item }}</div>
									</div>
									<el-input disabled v-model="detailData.serviceContractNo" :class="{'multi-value-input': serviceContractMultiple}"></el-input>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Contract Amount:">
								<el-input disabled v-model="detailData.contractAmount"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Payment Collection:">
								<el-input disabled v-model="detailData.paymentCollection"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Contract Registration:">
								<el-input disabled v-model="detailData.contractRegistration"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Service Subcontract:">
								<el-input disabled v-model="detailData.serviceSubcontractStatus"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Subcontract Amount:">
								<el-input disabled v-model="detailData.subcontractAmount"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Customer Tickets:">
								<el-input disabled v-model="detailData.customerTickets"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="RMA:">
								<el-input disabled v-model="detailData.rma"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
			</el-collapse-item>

			<!-- Risk Level & Items -->
			<el-collapse-item name="riskLevel">
				<template slot="title">
					<span class="card-header">Risk Level & Items</span>
					<!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click.stop="addRiskItem" style="position:absolute;right:50px">Add</el-button> -->
				</template>
				<el-row :gutter="20" class="risk-conclusion-row">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Deliverable Review Conclusion:">
							<el-input disabled v-model="detailData.deliverableReviewConclusion"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div v-for="(item, index) in riskItems" :key="index" class="risk-item-row">
					<el-row :gutter="20">
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Risk Level:">
								<el-select v-model="item.riskLevel" disabled placeholder="Please select" style="width:100%"
								:class="item.status !== 2 ? (item.riskLevel === 1 ? 'redbg' : item.riskLevel === 2 ? 'yellowbg' : item.riskLevel === 3 ? 'greenbg' : '') : ''">
									<el-option v-for="opt in riskLevelList" :key="opt.labelKey" :label="opt.labelValue" :value="opt.labelKey"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xl="8" :lg="8" :md="12">
							<el-form-item label="Status:">
								<el-select v-model="item.status" disabled placeholder="Please select" style="width:100%">
									<el-option v-for="opt in riskStatusList" :key="opt.labelKey" :label="opt.labelValue" :value="opt.labelKey"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<!-- <el-col :xl="8" :lg="8" :md="12">
							<el-form-item label=" ">
								<el-button size="mini" icon="el-icon-delete" style="background:#d61318;color:#fff;border-color:#d61318;" @click="removeRiskItem(index)">Delete</el-button>
							</el-form-item>
						</el-col> -->
					</el-row>
					<el-row :gutter="20">
						<el-col :xl="24" :lg="24" :md="24">
							<el-form-item label="Risk Description:">
								<el-input type="textarea" :rows="3" disabled v-model="item.riskDescription" maxlength="500"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-collapse-item>

			<!-- Process Indicator -->
			<el-collapse-item name="processIndicator">
				<template slot="title">
					<span class="card-header">Process Indicator</span>
					<span class="process-legend" style="font-size:12px;font-weight:400;color:#888;margin-left:16px;">（
						<span style="margin-left:5px;display:inline-block;width:12px;height:12px;background:#f5f5f5;border:1px solid #e8e8e8;border-radius:2px;vertical-align:middle;margin-right:3px;"></span>N/A
						<span style="margin-left:8px;display:inline-block;width:12px;height:12px;background:#fff;border:1px solid #DCDFE6;border-radius:2px;vertical-align:middle;margin-right:3px;"></span>Todo
						<span style="margin-left:8px;display:inline-block;width:12px;height:12px;background:#e6f7ff;border:1px solid #1890FF;border-radius:2px;vertical-align:middle;margin-right:3px;"></span>Ongoing
						<span style="margin-left:8px;display:inline-block;width:12px;height:12px;background:#52c41a;border-radius:2px;vertical-align:middle;margin-right:3px;"></span>Done
					）</span>
					<el-tooltip popper-class="process-tips-popper" placement="top">
						<div slot="content" class="process-tips-content">
							<div class="tips-section">
								<div class="tips-section-title">Tips:</div>
								<div class="tips-row"><span class="tips-key">Opp</span><span class="tips-val">IPMS Opportunity</span></div>
								<div class="tips-row"><span class="tips-key">Project Order</span><span class="tips-val">二级订单</span></div>
								<div class="tips-row"><span class="tips-key">Product Order</span><span class="tips-val">一级订单</span></div>
								<div class="tips-row"><span class="tips-key">Credit Control</span><span class="tips-val">信控</span></div>
								<div class="tips-row"><span class="tips-key">Service Registration</span><span class="tips-val">服务转交付</span></div>
								<div class="tips-row"><span class="tips-key">Order&amp;Shipment</span><span class="tips-val">Only indicate for Product Order</span></div>
							</div>
							<div class="tips-section">
								<div class="tips-section-title">Contact:</div>
								<div class="tips-row"><span class="tips-key">Credit Control Release</span><span class="tips-val">Huang Ziwen/Zoe 30302 , Shen Zhe 33587，Liang Yaoyao 33534</span></div>
								<div class="tips-row"><span class="tips-key">Service Registration</span><span class="tips-val">Qu Jinfan/Jerry  27229  , Zhang Liyuan  43324</span></div>
							</div>
						</div>
						<span class="process-tips-trigger">Tips<i class="el-icon-info process-tips-icon"></i></span>
					</el-tooltip>
				</template>
				<div class="process-grid">
					<div class="process-column" v-for="(stage, idx) in processData" :key="idx">
						<div class="process-stage" style="background:#d61318;">{{ stage.stageName }}</div>
						<div class="process-tags">
							<span
								v-for="node in stage.nodes"
								:key="node.nodeName"
								class="process-tag"
								:class="getNodeClass(node)"
							>{{ getNodeText(node) }}</span>
						</div>
					</div>
				</div>
			</el-collapse-item>

			<!-- Delivery Partner -->
			<el-collapse-item name="deliveryPartner">
				<template slot="title"><span class="card-header">Delivery Partner</span></template>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Project Delivery by Partner:">
							<el-radio-group v-model="detailData.projectDeliveryByPartner">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Country:">
							<el-select clearable filterable v-model="detailData.country" placeholder="Please select" style="width:100%" @change="handleCountryChange">
								<el-option v-for="item in svcDeliveryCountryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Partner Code/Name:">
							<el-select clearable filterable remote :remote-method="handlePartnerNameSearch" :loading="detailPartnerLoading" v-model="detailData.partnerCode" placeholder="Please input keyword" style="width:100%" @change="handlePartnerNameSelect">
								<el-option v-for="item in detailPartnerList" :key="item.partnerCode" :label="item.partnerCode + ' | ' + item.companyName" :value="item.partnerCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Partnership Category:">
							<el-input disabled v-model="detailData.partnershipCategory"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Service Partner Category:">
							<el-input disabled v-model="detailData.servicePartnerCategory"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Mgmt. Check by H3C:">
							<el-radio-group v-model="detailData.mgmtCheckByH3c">
								<el-radio :label="true">Yes</el-radio>
								<el-radio :label="false">No</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :xl="8" :lg="8" :md="12">
						<el-form-item label="Named Engineer & JQC Match:">
							<el-input v-model="detailData.namedEngineerJqcMatch"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-collapse-item>
			</el-collapse>
		</el-form>
		
		<div class="detail-title-bar" style="justify-content: center">
			<div>
				<el-button size="small" type="primary" @click="$emit('save')">Save</el-button>
				<el-button size="small" @click="$emit('back')">Back</el-button>
			</div>
		</div>

		<!-- Product Order 弹窗 -->
		<el-dialog title="Product Order" :visible.sync="productOrderDialogVisible" width="1350px" top="5vh" :close-on-click-modal="false">
			<el-table :data="productOrderList" border size="small" style="width:100%" v-loading="productOrderLoading" :header-cell-style="{background:'#F5F5F9'}">
				<el-table-column prop="productbom" label="Product BOM" min-width="120"></el-table-column>
				<el-table-column prop="category" label="Product Type" min-width="120"></el-table-column>
				<el-table-column prop="productdesc" label="Product Description" min-width="260"></el-table-column>
				<el-table-column prop="productcount" label="Quantity" min-width="80"></el-table-column>
				<el-table-column prop="servicenumofyear" label="WTY Year" min-width="80"></el-table-column>
				<el-table-column prop="servicename" label="WTY Category" min-width="120"></el-table-column>
				<el-table-column prop="servicebom" label="WTY Code" min-width="120"></el-table-column>
			</el-table>
			<el-pagination
				v-if="productOrderTotal > 0"
				style="margin-top:12px;text-align:right;"
				@current-change="handleProductOrderPageChange"
				:current-page="productOrderPageNum"
				:page-size="productOrderPageSize"
				:total="productOrderTotal"
				layout="total, prev, pager, next, jumper"
			></el-pagination>
		</el-dialog>

		<!-- Service Contract 弹窗 -->
		<el-dialog title="Service Contract" :visible.sync="serviceContractDialogVisible" width="1350px" top="5vh" :close-on-click-modal="false">
			<el-table :data="serviceContractList" border size="small" style="width:100%" v-loading="serviceContractLoading" :header-cell-style="{background:'#F5F5F9'}">
				<el-table-column prop="productbom" label="Product BOM" min-width="100"></el-table-column>
				<el-table-column prop="productname" label="Product Name" min-width="120"></el-table-column>
				<el-table-column prop="productdesc" label="Product Description" min-width="260"></el-table-column>
				<el-table-column prop="productcount" label="Product Quantity" min-width="128"></el-table-column>
				<el-table-column prop="servicebom" label="Service BOM" min-width="120"></el-table-column>
				<el-table-column prop="servicename" label="Service Description" min-width="160"></el-table-column>
				<el-table-column prop="servicecount" label="Service Quantity" min-width="125"></el-table-column>
				<el-table-column prop="servicenumofyear" label="Service Year" min-width="100"></el-table-column>
				<el-table-column prop="category" label="Product Line" min-width="120"></el-table-column>
			</el-table>
			<el-pagination
				v-if="serviceContractTotal > 0"
				style="margin-top:12px;text-align:right;"
				@current-change="handleServiceContractPageChange"
				:current-page="serviceContractPageNum"
				:page-size="serviceContractPageSize"
				:total="serviceContractTotal"
				layout="total, prev, pager, next, jumper"
			></el-pagination>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'ProjectDetail',
	props: {
		detailData: { type: Object, default: () => ({}) },
		detailLoading: { type: Boolean, default: false },
		processData: { type: Array, default: () => [] },
		riskItems: { type: Array, default: () => [] },
		businessTypeList: { type: Array, default: () => [] },
		projectLevelList: { type: Array, default: () => [] },
		representativeOfficeList: { type: Array, default: () => [] },
		industryList: { type: Array, default: () => [] },
		subIndustryList: { type: Array, default: () => [] },
		hwDeliveryCountryList: { type: Array, default: () => [] },
		svcDeliveryCountryList: { type: Array, default: () => [] },
		tier1PartnerList: { type: Array, default: () => [] },
		slaList: { type: Array, default: () => [] },
		projectStatusList: { type: Array, default: () => [] },
		detailPartnerList: { type: Array, default: () => [] },
		detailPartnerLoading: { type: Boolean, default: false },
	},
	data() {
		return {
			activeCollapseNames: ['keyInfo', 'detailInfo', 'riskLevel', 'processIndicator', 'deliveryPartner'],
			productOrderDialogVisible: false,
			productOrderLoading: false,
			productOrderList: [],
			productOrderPageNum: 1,
			productOrderPageSize: 10,
			productOrderTotal: 0,
			serviceContractDialogVisible: false,
			serviceContractLoading: false,
			serviceContractList: [],
			serviceContractPageNum: 1,
			serviceContractPageSize: 10,
			serviceContractTotal: 0,
			riskLevelList: [],
			riskStatusList: [],
		}
	},
	computed: {
		serviceContractMultiple() {
			return this.detailData.serviceContractNo && this.detailData.serviceContractNo.includes(';')
		},
		serviceContractItems() {
			if (!this.detailData.serviceContractNo) return []
			return this.detailData.serviceContractNo.split(';').map(item => item.trim()).filter(item => item)
		},
		projectOrderNoMultiple() {
			return this.detailData.projectOrderNo && this.detailData.projectOrderNo.includes(';')
		},
		projectOrderNoItems() {
			if (!this.detailData.projectOrderNo) return []
			return this.detailData.projectOrderNo.split(';').map(item => item.trim()).filter(item => item)
		},
		productOrderNoMultiple() {
			return this.detailData.productOrderNo && this.detailData.productOrderNo.includes(';')
		},
		productOrderNoItems() {
			if (!this.detailData.productOrderNo) return []
			return this.detailData.productOrderNo.split(';').map(item => item.trim()).filter(item => item)
		},
	},
	created() {
		this.fetchRiskSelectOptions()
	},
	methods: {
		toggleDetailInfo() {
			if (this.activeCollapseNames.includes('detailInfo')) {
				this.activeCollapseNames = this.activeCollapseNames.filter(n => n !== 'detailInfo')
			} else {
				this.activeCollapseNames = [...this.activeCollapseNames, 'detailInfo']
			}
		},
		fetchRiskSelectOptions() {
			let url = `${this.$store.state.islhurl}configMain/queryLabelList?`
			const configKeyList = ['riskLevel', 'riskStatus']
			let str = ''
			configKeyList.forEach(item => {
				str += `&configKeyList=${item}`
			})
			url = url + str.substring(1)
			this._post(url).then(res => {
				if (res.data && res.code === 200) {
					Object.keys(res.data).forEach(key => {
						if (key === 'riskLevel') {
							this.riskLevelList = res.data[key]
						} else if (key === 'riskStatus') {
							this.riskStatusList = res.data[key]
						}
					})
				}
			})
		},
		openProductOrder() {
			this.productOrderDialogVisible = true
			this.productOrderPageNum = 1
			this.fetchProductOrder()
		},
		fetchProductOrder() {
			this.productOrderLoading = true
			this.productOrderList = []
			const projectNumber = this.detailData.projectNumber
			const url = `${this.$store.state.islhurl}project-digital-brain/product-order/${projectNumber}?pageNum=${this.productOrderPageNum}&pageSize=${this.productOrderPageSize}`
			this._get(url).then(res => {
				this.productOrderLoading = false
				if (res.code === 200) {
					this.productOrderList = res.data || []
					this.productOrderTotal = res.totalSize || 0
				} else {
					this.productOrderList = []
					this.productOrderTotal = 0
					this.$message.error(res.msg || 'Failed to load Product Order data!')
				}
			}).catch(() => {
				this.productOrderLoading = false
				this.productOrderList = []
				this.productOrderTotal = 0
				this.$message.error('Product Order API request failed!')
			})
		},
		handleProductOrderPageChange(page) {
			this.productOrderPageNum = page
			this.fetchProductOrder()
		},
		openServiceContract() {
			this.serviceContractDialogVisible = true
			this.serviceContractPageNum = 1
			this.fetchServiceContract()
		},
		fetchServiceContract() {
			this.serviceContractLoading = true
			this.serviceContractList = []
			const projectNumber = this.detailData.projectNumber
			const url = `${this.$store.state.islhurl}project-digital-brain/service-contract/${projectNumber}?pageNum=${this.serviceContractPageNum}&pageSize=${this.serviceContractPageSize}`
			this._get(url).then(res => {
				this.serviceContractLoading = false
				if (res.code === 200) {
					this.serviceContractList = res.data || []
					this.serviceContractTotal = res.totalSize || 0
				} else {
					this.serviceContractList = []
					this.serviceContractTotal = 0
					this.$message.error(res.msg || 'Failed to load Service Contract data!')
				}
			}).catch(() => {
				this.serviceContractLoading = false
				this.serviceContractList = []
				this.serviceContractTotal = 0
				this.$message.error('Service Contract API request failed!')
			})
		},
		handleServiceContractPageChange(page) {
			this.serviceContractPageNum = page
			this.fetchServiceContract()
		},
		handleCountryChange() {
			this.detailData.partnerCode = ''
			this.detailData.partnerName = ''
			this.detailData.partnershipCategory = ''
			this.detailData.servicePartnerCategory = ''
			this.$emit('search-partner-name', '', this.detailData.country)
		},
		handlePartnerNameSearch(query) {
			this.$emit('search-partner-name', query, this.detailData.country)
		},
		handlePartnerNameSelect(val) {
			const partner = this.detailPartnerList.find(item => item.partnerCode === val)
			if (partner) {
				this.detailData.partnerName = partner.companyName || ''
				this.detailData.partnershipCategory = partner.partnershipCategory || ''
				this.detailData.servicePartnerCategory = partner.servicePartnerCategory || ''
			} else {
				this.detailData.partnerName = ''
				this.detailData.partnershipCategory = ''
				this.detailData.servicePartnerCategory = ''
			}
		},
		addRiskItem() {
			this.riskItems.push({ riskLevel: '', status: '', riskDescription: '' })
		},
		removeRiskItem(index) {
			this.riskItems.splice(index, 1)
		},
		getNodeClass(node) {
			const statusMap = { '已完结': 'done', '正处于': 'current', '未开始': 'todo', '不涉及': 'na' }
			return statusMap[node.nodeStatus] || 'todo'
		},
		getNodeText(node) {
			if (node.nodeValue) return `${node.nodeName}(${node.nodeValue})`
			return node.nodeName
		},
	},
}
</script>

<style lang="less" scoped>
.detail-page {
	.detail-title-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 16px;
		h2 {
			font-size: 18px;
			font-weight: 600;
			color: #1E3A6F;
			margin: 0;
			display: flex;
			align-items: center;
			&::before {
				content: '';
				width: 4px;
				height: 20px;
				background: #1890FF;
				border-radius: 2px;
				margin-right: 8px;
			}
		}
	}
	.detail-collapse {
		border: none;
		/deep/.el-collapse-item {
			margin-bottom: 16px;
			border: 1px solid #EBEEF5;
			border-radius: 4px;
			box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
			overflow: hidden;
		}
		/deep/.el-collapse-item__header {
			padding: 10px 20px;
			background: #FAFAFA;
			border-bottom: 1px solid #DCDFE6;
			height: auto;
			line-height: 30px;
			font-size: 14px;
			color: #1890FF;
			font-weight: 600;
			position: relative;
		}
		/deep/.el-collapse-item__wrap {
			border-bottom: none;
		}
		/deep/.el-collapse-item__content {
			padding: 14px 20px;
		}
		/deep/.el-collapse-item__arrow {
			margin-right: 8px;
		}
	}
	.card-header {
		font-size: 14px;
		font-weight: 600;
		color: #1890FF;
	}
	/deep/.el-form-item {
		margin-bottom: 12px;
	}
	/deep/.el-textarea.is-disabled .el-textarea__inner {
		color: #606266 !important;
	}
	/deep/.el-form-item__label {
		font-size: 13px;
		color: #888;
		font-weight: 500;
	}
	/deep/.red-label .el-form-item__label {
		color: #e73131 !important;
	}
	/deep/.no-col-padding-left {
		padding-left: 0 !important;
	}
	/deep/.no-label-padding-right .el-form-item__label {
		padding-right: 0;
		width: 210px !important;
	}
	/deep/.no-label-padding-right .el-form-item__content {
		margin-left: 210px !important;
	}
	/deep/.el-form-item__content .el-input__suffix {
		left: auto;
		right: 10px;
	}
	/deep/.el-radio.is-disabled {
		.el-radio__label {
			color: #606266 !important;
		}
	}
	/deep/.el-radio.is-checked.is-disabled {
		.el-radio__inner {
			background-color: #409EFF !important;
			border-color: #409EFF !important;
			&::after {
				background-color: #fff !important;
			}
		}
		.el-radio__label {
			color: #409EFF !important;
		}
	}
	.detail-link {
		color: #1890FF;
		cursor: pointer;
		text-decoration: underline;
		font-size: 13px;
		&:hover {
			color: #096DD9;
		}
		&.detail-link-disabled {
			color: #C0C4CC;
			cursor: not-allowed;
			&:hover {
				color: #C0C4CC;
			}
		}
	}
	.risk-conclusion-row {
		padding-bottom: 10px;
		border-bottom: 1px solid #DCDFE6;
		margin-bottom: 10px;
	}
	.risk-item-row {
		padding-bottom: 12px;
		margin-bottom: 12px;
		border-bottom: 1px dashed #DCDFE6;
		&:last-child {
			border-bottom: none;
			margin-bottom: 0;
			padding-bottom: 0;
		}
	}
	.redbg /deep/.el-input__inner {
		background: #d61318;
	}
	.yellowbg /deep/.el-input__inner {
		background: #FFFF00;
	}
	.greenbg /deep/.el-input__inner {
		background: #92D050;
	}
	.multi-value-input /deep/.el-input__inner {
		cursor: pointer;
		color: #1890FF;
	}
	.multi-value-input:hover /deep/.el-input__inner {
		border-color: #1890FF;
	}

	/* Dialog Table Header */
	/deep/.el-dialog .el-table th.el-table__cell > .cell {
		word-break: break-word;
	}

	/* Process Indicator */
	.process-grid {
		display: flex;
		gap: 8px;
		.process-column {
			flex: 1 1 auto;
			min-width: 0;
			display: flex;
			flex-direction: column;
			gap: 8px;
		}
		.process-stage {
			border-radius: 4px;
			padding: 8px 6px;
			text-align: center;
			color: #fff;
			font-size: 14px;
			font-weight: 600;
		}
		.process-tags {
			display: flex;
			flex-wrap: nowrap;
			gap: 4px;
		}
		.process-tag {
			flex: 1 1 auto;
			min-width: 0;
			padding: 4px 2px;
			border-radius: 4px;
			font-size: 12px;
			font-weight: 600;
			cursor: default;
			text-align: center;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			&.done {
				background: #52c41a;
				color: #fff;
			}
			&.current {
				background: #e6f7ff;
				color: #1890FF;
			}
			&.todo {
				background: #fff;
				color: #333;
				border: 1px solid #DCDFE6;
			}
			&.na {
				background: #f5f5f5;
				color: #bbb;
				border: 1px solid #e8e8e8;
			}
			&.maintenance {
				background: #13c2c2;
				color: #fff;
			}
		}
	}

	.process-tips-trigger {
		display: inline-flex;
		align-items: center;
		vertical-align: middle;
		color: #e84b4f;
		padding-left: 5px;
	}

	.process-tips-icon {
		margin-left: 3px;
		font-size: 16px;
		cursor: pointer;
		vertical-align: middle;
		padding-top: 4px;
	}
}
</style>

<style>

.process-tips-popper {
	background: #fff !important;
	border: 1px solid #e8e8e8 !important;
	border-radius: 6px !important;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
	max-width: 420px !important;
}

.process-tips-popper .popper__arrow {
	border-top-color: #e8e8e8 !important;
}

.process-tips-popper .popper__arrow::after {
	border-top-color: #fff !important;
}

.process-tips-content {
	font-size: 13px;
	color: #333;
}

.process-tips-content .tips-section {
	padding: 8px 0;
}

.process-tips-content .tips-section:first-child {
	border-bottom: 1px dashed #e0e0e0;
}

.process-tips-content .tips-section-title {
	font-weight: 600;
	color: #1890FF;
	margin-bottom: 6px;
	font-size: 13px;
}

.process-tips-content .tips-row {
	display: flex;
	line-height: 1.8;
}

.process-tips-content .tips-key {
	min-width: 140px;
	color: #666;
	font-weight: 500;
	flex-shrink: 0;
}

.process-tips-content .tips-val {
	color: #333;
	flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/keyFocusProjects/ProjectDetail.vue